import React from 'react';
import ApolloError from '@shared/components/ApolloError';
import ReportDataMapper from '../../../mappers/ReportDataMapper';
import { useQuery } from '@apollo/client';
import DeltaReportTable from './DeltaReportTable';
import MotionSection from '@shared/components/animations/MotionSection';
import GET_FDA_CONTRACT_DELTA_REPORT from '../../../queries/getFdaContractDeltaReportQuery';

/**
 * @typedef {object} SACDeltaViewProps
 * @property {Array<Object>} deltaInstances
 * @property {Array<number>} ohts
 * @property {number} [orgId]
 */

/**
 * @param {SACDeltaViewProps} props
 */
const SACDeltaView = props => {
  const { deltaInstances, ohts, orgId } = props;

  const {
    data: deltaData,
    loading: deltaDataLoading,
    error: deltaDataError
  } = useQuery(GET_FDA_CONTRACT_DELTA_REPORT, {
    variables: { deltaInstances: deltaInstances.map(x => x.value), ohts, orgId }
  });

  const deltaReportData = deltaData?.fdaContractDeltaReport.map(
    ReportDataMapper.mapFdaDeltaPracticeArea
  );

  if (deltaDataError) {
    return <ApolloError />;
  }

  return (
    <MotionSection keyProp={JSON.stringify(deltaInstances)}>
      <DeltaReportTable
        data={deltaReportData}
        deltaInstances={deltaInstances}
        loading={deltaDataLoading}
      />
    </MotionSection>
  );
};

export default SACDeltaView;
